import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import logger from 'loglevel';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore todo: проблема при билде
import { Deferred } from 'class-deferred';
import { BaseBroker } from "./BaseBroker";
logger.setLevel(logger.levels.INFO);
var BEEF_CO_MESSAGE_TYPE = 'beefCo';
var EVENT_FRAME_CONNECTED = 'connected';
var EVENT_PARENT_CONNECTED = 'connected_ack';

/**
 * Брокер для передачи команд между веб-сайтом и iFrame'ом на базе postMessage
 */
export var FrameBroker = /*#__PURE__*/function (_BaseBroker) {
  _inherits(FrameBroker, _BaseBroker);
  var _super = _createSuper(FrameBroker);
  function FrameBroker() {
    var _this;
    _classCallCheck(this, FrameBroker);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "targetElement", void 0);
    _defineProperty(_assertThisInitialized(_this), "targetOrigin", void 0);
    _defineProperty(_assertThisInitialized(_this), "loadedAsync", new Deferred());
    _defineProperty(_assertThisInitialized(_this), "handleMessage", function (message) {
      var _this$targetElement;
      if (_this.isAllowedOrigin(message.origin) && message.data.type === BEEF_CO_MESSAGE_TYPE) {
        switch (message.data.event) {
          case EVENT_FRAME_CONNECTED:
            /**
             * Шаг 2. Платформа получает сообщение от фрейма и посылает подтверждение
             */
            (_this$targetElement = _this.targetElement) === null || _this$targetElement === void 0 ? void 0 : _this$targetElement.postMessage({
              type: BEEF_CO_MESSAGE_TYPE,
              event: EVENT_PARENT_CONNECTED
            }, _this.targetOrigin);
            _this.loadedAsync.resolve();
            break;
          case EVENT_PARENT_CONNECTED:
            /**
             * Шаг 3. Получив подтверждение от платформы, фрейм тоже считает себя инициализированным
             */
            _this.loadedAsync.resolve();
            break;
          default:
            _this.receive(message.data.payload);
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "isAllowedOrigin", function (messageOrigin) {
      return messageOrigin === _this.targetOrigin || _this.targetOrigin === '*';
    });
    return _this;
  }
  _createClass(FrameBroker, [{
    key: "connect",
    value: function connect(targetElement, targetOrigin) {
      logger.info('[FrameBroker] Started');
      this.targetOrigin = targetOrigin;
      this.targetElement = targetElement;
      window.addEventListener('message', this.handleMessage);
      this.onReady(function () {
        return logger.info('[FrameBroker] Connected');
      });

      /**
       * Шаг 1. Первым устанавливает соединение дочерний компонент
       */
      if (window.parent === targetElement) {
        this.targetElement.postMessage({
          type: BEEF_CO_MESSAGE_TYPE,
          event: EVENT_FRAME_CONNECTED
        }, this.targetOrigin);
      }
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      this.targetElement = undefined;
      this.targetOrigin = undefined;
      this.loadedAsync = new Deferred();
      window.removeEventListener('message', this.handleMessage);
    }
  }, {
    key: "onReady",
    value: function onReady(fn) {
      this.loadedAsync.then(fn).catch(function () {});
    }
  }, {
    key: "send",
    value: function send(msg, extra, ack) {
      if (typeof ack === 'function') {
        /** @class RoundTripCommand */
        throw new Error('FrameBroker не поддерживает требующие ответа команды (RoundTripCommand)');
      }
      if (!this.targetElement || !this.targetOrigin) {
        throw Error('Attempting to call send before connecting FrameTransport');
      }
      try {
        // FIXME: need acknowledge
        this.targetElement.postMessage({
          payload: msg,
          type: BEEF_CO_MESSAGE_TYPE
        }, this.targetOrigin);
      } catch (err) {
        logger.error('Unable to postMessage, arguments are most likely not serializable');
        throw err;
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.loadedAsync.reject();
    }
  }]);
  return FrameBroker;
}(BaseBroker);